import store from '@/store';
import { leadCreationRepository } from '@/forms/api/repository-factory';
import callApi from '@/lib/helpers/call-api';

const getProduct = function(prducttype) {
    if (prducttype === 'loan' || prducttype === 'Loan' || prducttype === 'LOAN') {
        return 'Personal Loan';
    } else if (prducttype === 'CREDIT CARD') {
        return 'Credit Card';
    } else {

        return "";
    }
}

const getPayload = () => {
    const { values } = store.state.formData;
    const {
        appId,
        cifnumber,
        source,
        medium,
        productId,
        productType
    } = store.state;
    const product = getValueByFieldName(values, FIELD_NAMES.product);
    var salesProduct;
    if (product === 'Top Up') {
        salesProduct = 'TOPUP'
    } else if (product === 'New Car' || product === 'Used Car') {
        salesProduct = 'Auto Loan'
    } else {

        salesProduct = product
    }
    undefined
    if (product === 'Top Up' || product === 'New Car' || product === 'Used Car') {
        return {
            "app-id": appId,
            "cif-number": cifnumber,
            "product": salesProduct,
            "utm-source": typeof source !== 'undefined' ? source : "",
            "utm-medium": typeof medium !== 'undefined' ? medium : "",
            "attribute1": "",
            "attribute2": "",
            "attribute3": "",
            "attribute4": "",
            "attribute5": "",
        };
    }
    return {
        "app-id": appId,
        "cif-number": cifnumber,
        "product": productType,
        "utm-source": typeof source !== 'undefined' ? source : "",
        "utm-medium": typeof medium !== 'undefined' ? medium : "",
        "attribute1": "",
        "attribute2": "",
        "attribute3": "",
        "attribute4": "",
        "attribute5": "",
    };
};

export default {
    async leadCreation(currentStep, callbacks) {
        const { form } = currentStep;
        let response = false;
        response = await callApi({
            callbacks,
            form,
            formElement: currentStep,
            apiCall: leadCreationRepository.leadCreation,
            payload: getPayload(),
        });
    }
};